import { Component, Input, OnInit } from '@angular/core';
import { Employee } from "../../core/models/employee.model";

@Component({
    selector: 'app-employment-show',
    templateUrl: './employment-show.component.html',
    styleUrls: ['./employment-show.component.css']
})
export class EmploymentShowComponent implements OnInit {

    @Input()
    employee: Employee;

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/verification-show/employment-show/employment-show.component.ts